import styled from 'styled-components';

export const AddContactDialogStyle = styled.div`
.rd-contact-management-add-contact-body{
  margin-bottom: 300px;
}

.after-box-submit{
  float: right;
  margin-right: 25px;
}
`;
